import { defineMessages } from 'react-intl';
var messages = defineMessages({
    Identification: {
        id: 'Identification',
        defaultMessage: 'Identification',
    },
    Name: {
        id: 'Name',
        defaultMessage: 'Name',
    },
    CommercialName: {
        id: 'CommercialName',
        defaultMessage: 'Commercial name',
    },
    BusinessNumber: {
        id: 'BusinessNumber',
        defaultMessage: 'Business number',
    },
    KvkNr: {
        id: 'KvkNr',
        defaultMessage: 'KvK nr.',
    },
    Address: {
        id: 'Address',
        defaultMessage: 'Address',
    },
    BankAccounts: {
        id: 'BankAccounts',
        defaultMessage: 'Bank accounts',
    },
    ModifyBankAccounts: {
        id: 'ModifyBankAccounts',
        defaultMessage: 'Modify bank accounts',
    },
    LegalForm: {
        id: 'LegalForm',
        defaultMessage: 'Legal form',
    },
    LegalEntity: {
        id: 'LegalEntity',
        defaultMessage: 'Legal entity',
    },
    VatNumber: {
        id: 'VatNumber',
        defaultMessage: 'VAT number',
    },
    NoVatLiability: {
        id: 'NoVatLiability',
        defaultMessage: 'No VAT liability',
    },
    RLP: {
        id: 'RLP',
        defaultMessage: 'RLP',
    },
    RegisterLegalPersons: {
        id: 'RegisterLegalPersons',
        defaultMessage: 'Register legal persons',
    },
    Phone: {
        id: 'Phone',
        defaultMessage: 'Phone',
    },
    Website: {
        id: 'Website',
        defaultMessage: 'Website',
    },
    Email: {
        id: 'Email',
        defaultMessage: 'Email',
    },
    ProfessionalAssociation: {
        id: 'ProfessionalAssociation',
        defaultMessage: 'Professional association',
    },
    Number: {
        id: 'number',
        defaultMessage: 'number',
    },
    IntraCompanyRelation: {
        id: 'IntraCompanyRelation',
        defaultMessage: 'Intra company relation',
    },
    AddCompany: {
        id: 'AddCompany',
        defaultMessage: 'Add company',
    },
    None: {
        id: 'None',
        defaultMessage: 'None',
    },
    msgConfirmChange: {
        id: 'msgConfirmChange',
        defaultMessage: 'Changes saved',
    },
    msgCompanyCBENotFound: {
        id: 'msgCompanyCBENotFound',
        defaultMessage: 'Company not found in CBE',
    },
    msgCompanyFillInEnterpriseNrCBE: {
        id: 'msgCompanyFillInEnterpriseNrCBE',
        defaultMessage: 'Please fill in the enterprise number',
    },
    btnEditEnterpriceNr: {
        id: 'btnEditEnterpriceNr',
        defaultMessage: 'Edit enterprise number',
    },
    msgRequiredField: {
        id: 'msgRequiredField',
        defaultMessage: 'This field is required',
    },
    msgIncompleteEntryInMaskIsNoSave: {
        id: 'msgIncompleteEntryInMaskIsNoSave',
        defaultMessage: 'Incomplete entry will not be saved',
    },
    CompanyNameRequiredForInvoicing: {
        id: 'CompanyNameRequiredForInvoicing',
        defaultMessage: 'Company name is required for invoicing',
    },
    BusinessNumberRequired: {
        id: 'BusinessNumberRequired',
        defaultMessage: 'Business number is required',
    },
    KvkNumberRequired: {
        id: 'KvkNumberRequired',
        defaultMessage: 'KvK number is required',
    },
    AddressIncomplete: {
        id: 'AddressIncomplete',
        defaultMessage: 'The address is incomplete and is required for invoicing',
    },
    IbanRequiredForInvoicing: {
        id: 'IbanRequiredForInvoicing',
        defaultMessage: 'IBAN is required for invoicing',
    },
    VatNumberRequiredForInvoicing: {
        id: 'VatNumberRequiredForInvoicing',
        defaultMessage: 'Vat number is required for invoicing',
    },
    IsRequiredForIntraCompanyBilling: {
        id: 'IsRequiredForIntraCompanyBilling',
        defaultMessage: 'Required for intra company billing',
    },
    BankAccountNr: {
        id: 'BankAccountNr',
        defaultMessage: 'Bank account nr.',
    },
    BIC: {
        id: 'BIC',
        defaultMessage: 'BIC',
    },
    Bank: {
        id: 'Bank',
        defaultMessage: 'Bank',
    },
    MainBankAccountTooltip: {
        id: 'MainBankAccountTooltip',
        defaultMessage: 'The main bank account will be used for the electronic invoice (UBL) and payment QR code',
    },
    AddBankAccount: {
        id: 'AddBankAccount',
        defaultMessage: 'Add bank account',
    },
    Save: {
        id: 'Save',
        defaultMessage: 'Save',
    },
    Close: {
        id: 'Close',
        defaultMessage: 'Close',
    },
    Cancel: {
        id: 'Cancel',
        defaultMessage: 'Cancel',
    },
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    Remove: {
        id: 'Remove',
        defaultMessage: 'Remove',
    },
    EnterpriseNumber: {
        id: 'EnterpriseNumber',
        defaultMessage: 'Enterprise number',
    },
    KVKNumber: {
        id: 'KvkNumber',
        defaultMessage: 'KVK number',
    },
    Country: {
        id: 'Country',
        defaultMessage: 'Country',
    },
    InvalidWebsite: {
        id: 'msgInvalidWebsite',
        defaultMessage: 'Please enter a valid website URL',
    },
});
export default messages;
